import container from './CQRS';

async function getMotivationalMessage() {
  return new Promise((resolve, reject) => {
    container.queriesController
      .fetchMotivationalMessage()
      .then(({ data }) => {
        resolve(data.content);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
}

async function setSession({ route, device }) {
  return await container.commandsController.setSessionRequest({ route, device });
}

async function getAboutUsInfo() {
  try {
    return await container.queriesController.fetchAboutUs();
  } catch (error) {
    throw new Error('[Service]: Opss!, we had a problem getting the information we needed.');
  }
}

async function getFAQS({ search, type }) {
  const queryParams =
    search && type ? `?${new URLSearchParams({ [type]: search }).toString()}` : '';
  try {
    return await container.queriesController.fetchAboutFaqs(queryParams);
  } catch (error) {
    throw new Error('[Service]: Opss!, we had a problem getting the FAQS.');
  }
}

async function getFAQSTopics() {
  try {
    return await container.queriesController.fetchFAQSTopics();
  } catch (error) {
    throw new Error('[Service]: Opss!, we had a problem getting the topics.');
  }
}

async function sentComment({ user_id, email, message, is_child }) {
  try {
    return await container.commandsController.sentComment({ user_id, email, message, is_child });
  } catch (error) {
    throw new Error('[Service]: Opss!, we cant sent the comment...');
  }
}

async function getTimeZones() {
  try {
    return await container.queriesController.settingsFetchTimeZones();
  } catch (error) {
    throw new Error('[Service]: Opss!, we had a problem getting the timezones...');
  }
}

async function getTimezone(userIsParent, userId) {
  try {
    return await container.queriesController.settingsFetchTimeZone({
      isParent: userIsParent,
      userId,
    });
  } catch (error) {
    console.log(error);
  }
}

async function getNotificationSetup(userIsParent, userId) {
  try {
    return await container.queriesController.settingFecthNotificationSetup({
      isParent: userIsParent,
      userId,
    });
  } catch (error) {
    throw new Error('[Service]: Opss!, we had a problem getting the setup to the notifications...');
  }
}

async function updateConfiguration(userIsParent, userId, payload) {
  try {
    const data = { ...payload, ...payload.notifications };
    return await container.commandsController.settingSentNitficationSetup({
      isParent: userIsParent,
      userId,
      payload: data,
    });
  } catch (error) {
    throw new Error('[Service]: Opss!, we had a problem sent the setup...');
  }
}

async function updateTimeZone(userIsParent, userId, time_zone) {
  try {
    return await container.commandsController.settingsUpdateTimeZone({
      isParent: userIsParent,
      userId,
      payload: { time_zone },
    });
  } catch (error) {
    throw new Error('[Service]: Opss!, we had a problem sent the setup...');
  }
}

async function getTips() {
  try {
    return await container.queriesController.fetchTips();
  } catch (error) {
    throw new Error('[Service]: Opps!, we had a problem getting the tips...');
  }
}

async function getParentByEmail(email) {
  try {
    return await container.queriesController.fetchParentByEmail({ email });
  } catch (error) {
    throw new Error('[Service]: Opps!, a child could not be assigned.');
  }
}

async function setParentAssignChildren(infoToShareCHild) {
  try {
    return await container.commandsController.setParentAssignChildren(infoToShareCHild);
  } catch (error) {
    throw new Error('[Service]: Opps!, unregistered parent.');
  }
}

async function setInviteParent(infoToShareCHild) {
  try {
    return await container.commandsController.setInviteParent(infoToShareCHild);
  } catch (error) {
    throw new Error('[Service]: Opps!, father could not be invited.');
  }
}

async function setChangeParentTheme(parentId, themeId) {
  try {
    return await container.commandsController.setChangeParentTheme({ parentId, themeId });
  } catch (error) {
    throw new Error('[Service]: Opps!, father could not change theme');
  }
}

async function setChangeChildTheme(childId, themeId) {
  try {
    return await container.commandsController.setChangeChildTheme({ childId, themeId });
  } catch (error) {
    throw new Error('[Service]: Opps!, child could not change theme');
  }
}

async function updateParentInformation(parentId, parentInformation) {
  try {
    return await container.commandsController.setParentInformation({ parentId, parentInformation });
  } catch (error) {
    throw new Error('[Service]: Opss!, I could not update parent information');
  }
}

async function updateChildInformation(parentId, childId, childformation) {
  try {
    return await container.commandsController.setChildInformation({ parentId, childId, childformation});
  } catch (error) {
    throw new Error('[Service]: Opss!, I could not update child information');
  }
}


export {
  getMotivationalMessage,
  setSession,
  getAboutUsInfo,
  getFAQS,
  getFAQSTopics,
  sentComment,
  getTimeZones,
  getTimezone,
  getNotificationSetup,
  updateConfiguration,
  updateTimeZone,
  getTips,
  getParentByEmail,
  setParentAssignChildren,
  setInviteParent,
  setChangeParentTheme,
  setChangeChildTheme,
  updateParentInformation,
  updateChildInformation,
};

